import { createApp } from 'vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

import App from './App.vue'
import router from './router'
import PageSection from './components/Page-Section.vue'

const app = createApp(App)

app.component('page-section', PageSection)
app.use(router)

app.mount('#app')
